'use strict';
import { Component, Inject, Input, Output, EventEmitter} from 'ng-metadata/core';
var angular:angular.IAngularStatic =  require('angular');

@Component({
    "selector": "prm-endnote",
    templateUrl: 'components/search/actions/endNoteAction/endnote.html'
})


export class PrmEndnote {
    @Output() closeTabsEvent = new EventEmitter<void>();


    constructor() {
    }

    ngOnInit() {
        this.closeTabsEvent.emit(null);
    }


}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/endNoteAction/endnote.directive.ts